var exports = {
  "k": "x4ddf2309--e73c1a--container",
  "U": "x4ddf2309--e73c1a--arrow",
};

module.exports = exports;
